import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateDocumentOperation = paths['/executor_web/identification/document']['patch'];

export type UpdateDocumentRequest = NonNullable<
	NonNullable<UpdateDocumentOperation['requestBody']>['content']['application/json']
>;
export type UpdateDocumentResponse =
	UpdateDocumentOperation['responses'][200]['content']['application/json'];

/** PATCH `/executor_web/identification/document` — см. `paths['/executor_web/identification/document']` в auth swagger */
export function updateDocument(request: UpdateDocumentRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateDocumentResponse>('identification/document', request, {signal});
}
